// Internal modules
import { appStore } from '@/store';

const isConversionNeeded = () => {
  const { cartAmount, griffinMetadata } = appStore.getState().api;
  const { currencyCode: cartCurrency } = cartAmount;
  const { currencyCode: localeCurrency } = griffinMetadata;

  /**
   * If this function is called before the initial data is
   * returned we'll just return `false`. This shouldn't ever
   * happen since the places this function is used, serializing the form
   * and fetching conversion data after a card number is entered, aren't
   * called until we have this information.
   */
  if (!cartCurrency || !localeCurrency) {
    return false;
  }

  return cartCurrency !== localeCurrency;
};

export { isConversionNeeded };
